/**
 * Standardized utility functions for parsing and transforming HLA and antibody data
 * across the cross-match and histocompatibility modules.
 */

/**
 * Transforms recipient HLA antibody array into standardized allele and rounded MFI objects.
 * @param {Array<{ antigen: string, MFI: number }>} inputArray
 * @returns {Array<{ allele: string, mfi: number }>}
 */
export function transformHLAData(inputArray) {
  if (!inputArray || !Array.isArray(inputArray)) return [];
  return inputArray
    .filter((item) => item && item.antigen)
    .map((item) => ({
      allele: item.antigen.trim(),
      mfi: Math.round(Number(item.MFI) || 0),
    }));
}

/**
 * Transforms donor HLA typing object into an alphabetically sorted array of allele objects.
 * @param {Object<string, string>} inputObject - Object containing HLA locus alleles (e.g. HLA_A_Allele_1)
 * @returns {Array<{ allele: string }>}
 */
export function transformHLAAlleles(inputObject) {
  if (!inputObject || typeof inputObject !== "object") return [];
  const alleles = [];

  for (const [key, value] of Object.entries(inputObject)) {
    if (key.includes("Allele") && typeof value === "string" && value.trim() !== "") {
      alleles.push({ allele: value.trim() });
    }
  }

  return alleles.sort((a, b) => a.allele.localeCompare(b.allele));
}
